import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
  ],
  template: `
    <div class="not-found-container">
      <mat-card>
        <mat-card-header>
          <mat-icon color="warn" class="error-icon">error_outline</mat-icon>
          <h1 class="title">404 - Página no encontrada</h1>
        </mat-card-header>
        <mat-card-content>
          <p>Lo sentimos, la página que buscas no existe o ha sido movida.</p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button color="primary" routerLink="/">
            Volver al inicio
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  `,
  styles: [
    `
      .not-found-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        text-align: center;
      }
      mat-card {
        max-width: 400px;
        padding: 20px;
        box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);
      }
      .error-icon {
        font-size: 48px;
        color: #d32f2f;
      }
      .title {
        font-size: 1.5rem;
        margin-left: 10px;
      }
      mat-card-actions {
        display: flex;
        justify-content: center;
      }
    `,
  ],
})
export class NotFoundComponent {}
